import { Text } from "@mantine/core";

export function CompletionBadge({ totalSteps, completedSteps }: { totalSteps: number; completedSteps: number }) {
    const isDone = totalSteps === completedSteps;

    return isDone ? (
        <Text size="xs" bg="success.9" px={"xs"} py={2} bdrs={"xs"}>
            Done
        </Text>
    ) : (
        <Text size="xs" bg="gray.8" px={"xs"} py={2} bdrs={"xs"}>
            {completedSteps}/{totalSteps}
        </Text>
    );
}
